function get_faq_btn(handle){
  
  let btn = '<modal-opener class="product-popup-modal__opener quick-add-hidden faq_btn ' + handle + '" data-modal="#PopupModal-popup_my-modal">';
  btn +=    '<button class="product-popup-modal__button link" type="button" aria-haspopup="dialog" onclick="load_faq(\'' + handle + '\')">';
  btn +=    '<span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-accordion icon-question-mark" viewBox="0 0 20 20">';
  btn +=    '<path d="M9.563 11.959a.367.367 0 0 1-.367-.367v-.127c-.003-.49.084-.91.316-1.303.227-.384.575-.715 1.04-1.063.415-.311.666-.566.817-.81a1.43 1.43 0 0 0 .208-.795v-.013c0-.894-.657-1.531-1.568-1.531-.862 0-1.527.606-1.612 1.609a.37.37 0 0 1-.097.219l-.006.006a.37.37 0 0 1-.264.117l-.471.007a.367.367 0 0 1-.362-.453c.112-1.519 1.219-2.712 2.825-2.712 1.603 0 2.791 1.176 2.791 2.718v.013c0 .512-.114.965-.366 1.387-.248.416-.619.783-1.101 1.145l-.003.002c-.414.305-.637.526-.764.738-.12.2-.172.422-.172.771v.075a.367.367 0 0 1-.367.367zm1.142 2.423c0 .473-.335.88-.838.88-.497 0-.845-.4-.845-.88 0-.477.351-.874.845-.874.5 0 .838.403.838.874"/><path d="M18.5 10a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0M10 17.497a7.497 7.497 0 1 0 0-14.994 7.497 7.497 0 0 0 0 14.994"/>';
  btn +=    '</svg></span>';
  btn +=    '</button>';
  btn +=    '</modal-opener>';
 
  return btn;
}

function load_faq(handle){

  if(faqs[handle] !== undefined){
 
    // put content into modal
    // get modal   
    const m = document.getElementById("PopupModal-popup_my-modal");
    // get header
    const h2 = m.querySelector('.product-popup-modal__content-info h2 span');
    // set new header
    h2.innerHTML = faqs[handle]['f'];
    // get body
    const b = m.querySelector('.product-popup-modal__content-info .my_modal_body');
    b.innerHTML = faqs[handle]['a'];
  
    // add image if available
    if(faqs[handle]['b'] !== undefined){
      b.innerHTML =   b.innerHTML + '<p class=""><img src="' + faqs[handle]['b'] + '" width="1000" height=""></p>';
    }

    $('.product-popup-modal__content').scrollTop(0);
   
  }
}



function set_faq_btns(type){
    
  if(type == 'variants'){
    // set variants btns
    let variant_dr = $('variant-selects fieldset:first-child');
    let variant_oa = $('variant-selects fieldset:nth-child(2)');

    if($(variant_dr).length){ $(variant_dr).find('legend').append(get_faq_btn('drehrichtung')) }
    if($(variant_oa).length){ $(variant_oa).find('legend').append(get_faq_btn('oberflache-aussen')) }

  }
  
  if(type == 'options'){

    // walk faqs and search for option dom items with id
    for (let key in faqs) {
      let faq = faqs[key];

      if(faq.option_dom_ids !== undefined && typeof faq.option_dom_ids){

        for (let k in faq.option_dom_ids) {
          let po_id = '#' + faq.option_dom_ids[k];
          //console.log(po_id);
          if($(po_id).length) $(po_id).first().append(get_faq_btn(key));
        }  
      }
    }


    
    /*
    // Sonderfarbe RAL
    let detail_sonderfarbe = $('#po_stack542128, #po_stack541261, #po_stack542139, #po_stack454664');
    if($(detail_sonderfarbe).length) $(detail_sonderfarbe).first().append(get_faq_btn('ral-farbe'));
    
    // Oberfläche innen
    let detail_oinnen = $('#po_stack419358, #po_stack419360, #po_stack542137, #po_stack454645, #po_stack542126, #po_stack541258');
    if($(detail_oinnen).length) $(detail_oinnen).first().append(get_faq_btn('oberflache-innen'));



    // Zusatz-daemmung
    let detail_zusatz_rahmendammung = $('#po_stack556849, #po_stack556902');
    if($(detail_zusatz_rahmendammung).length) $(detail_zusatz_rahmendammung).first().append(get_faq_btn('zusatz-rahmendammung'));    
   
    // GLAS
    let detail_glas_e = $('#po_stack418867');
    if($(detail_glas_e).length) $(detail_glas_e).first().append(get_faq_btn('glas-e'));
    let detail_glas_i = $('#po_stack454644');
    if($(detail_glas_i).length) $(detail_glas_i).first().append(get_faq_btn('glas-i'));
    
    // Dimension Breite
    let detail_dimension_breite = $('#po_stack418669, #po_stack418861, #po_stack454642, #po_stack542135, #po_stack542122, #po_stack541256');
    if($(detail_dimension_breite).length) $(detail_dimension_breite).first().append(get_faq_btn('dimension-breite'));
    
    // Dimension Höhe
    let detail_dimension_hohe = $('#po_stack418672, #po_stack418863, #po_stack454639, #po_stack541253, #po_stack542121, #po_stack542134');
    if($(detail_dimension_hohe).length) $(detail_dimension_hohe).first().append(get_faq_btn('dimension-hohe'));
     
    // //Drücker Außen
    let detail_aussengriff_e = $('#po_stack417847, #po_stack418858');
    if($(detail_aussengriff_e).length) $(detail_aussengriff_e).first().append(get_faq_btn('aussengriff-e'));
    let detail_aussengriff_i = $('#po_stack454637, #po_stack542132, #po_stack541252, #po_stack542120');
    if($(detail_aussengriff_i).length) $(detail_aussengriff_i).first().append(get_faq_btn('aussengriff-i'));
    
    // Zubehör Beschlag
    let detail_zubehor_beschlag_e = $('#po_stack417725, #po_stack418857');
    if($(detail_zubehor_beschlag_e).length) $(detail_zubehor_beschlag_e).first().append(get_faq_btn('zubehor-beschlag-e'));

    let detail_zubehor_beschlag_i = $('#po_stack454636, #po_stack542136, #po_stack541254, #po_stack542124');
    if($(detail_zubehor_beschlag_i).length) $(detail_zubehor_beschlag_i).first().append(get_faq_btn('zubehor-beschlag-i'));

    
    // 5-Punkt-Automatik
    let detail_5_punkt_automatik_e = $('#po_stack424654, #po_stack424659');
    if($(detail_5_punkt_automatik_e).length) $(detail_5_punkt_automatik_e).first().append(get_faq_btn('5-punkt-automatik-e'));

    let detail_5_punkt_automatik_i = $('#po_stack454647, #po_stack542138, #po_stack541260, #po_stack542127');
    if($(detail_5_punkt_automatik_i).length) $(detail_5_punkt_automatik_i).first().append(get_faq_btn('verriegelung-i'));

    
    // Sicherheitspaket
    let detail_sicherheitspaket_e = $('#po_stack424546, #po_stack424630');
    if($(detail_sicherheitspaket_e).length) $(detail_sicherheitspaket_e).first().append(get_faq_btn('sicherheitspaket-oem-e'));
    let detail_sicherheitspaket_i = $('#po_stack454646, #po_stack542141, #po_stack541259, #po_stack542130');
    if($(detail_sicherheitspaket_i).length) $(detail_sicherheitspaket_i).first().append(get_faq_btn('sicherheitspaket-i'));
   
    // Bodeneinstandsprofil
    let detail_bodeneinstandsprofil = $('#po_stack418680, #po_stack418864');
    if($(detail_bodeneinstandsprofil).length) $(detail_bodeneinstandsprofil).first().append(get_faq_btn('bodeneinstandsprofil-e'));
     
    // Montage-Set
    let detail_montage_set_e = $('#po_stack418144, #po_stack418860');
    if($(detail_montage_set_e).length) $(detail_montage_set_e).first().append(get_faq_btn('montage-set-e'));

    let detail_montage_set_i = $('#po_stack454641, #po_stack542142, #po_stack541255, #po_stack542125');
    if($(detail_montage_set_i).length) $(detail_montage_set_i).first().append(get_faq_btn('montage-set-i'));
    */
  }
}